import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Text,
} from "@chakra-ui/react";

interface IFormUser {
  isOpen: boolean;
  onClose: () => void;
}

const FormUser = ({ isOpen, onClose }: IFormUser) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Modal Title</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text>
            Lorem ipsum dolor, sit amet consectetur adipisicing elit.
            Necessitatibus excepturi iusto a at temporibus velit debitis
            doloribus voluptates, placeat asperiores dignissimos obcaecati quod
            sed provident aliquam quo ab saepe libero.
          </Text>
        </ModalBody>

        <ModalFooter>
          <Button colorScheme="blue" mr={3} onClick={onClose}>
            Close
          </Button>
          <Button variant="ghost">Secondary Action</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default FormUser;
